<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.available_product") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="loadData()" :loading="loading">
            <i class="fa fa-refresh"></i> {{ $t("refresh") }}
          </base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                :placeholder="$t('search')"
              >
              </base-input>

              <div class="col-md-1">
                <base-button
                  size="md"
                  type="neutral"
                  @click="exportData()"
                >
                  Export
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="ProductID"
              header-row-class-name="thead-light"
              v-loading="loading"
            >
              <el-table-column width="120">
                <div slot-scope="{ row }" class="d-flex">
                  <img :src="GetProductUrl(row.Image)" height="80px" v-if="row.Image && (row.Image.includes('.png') || row.Image.includes('.jpg') || row.Image.includes('jpeg'))"/>
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.product_name')" min-width="150" sortable prop="ProductName">
                <div slot-scope="{ row }">
                  {{ row.ProductName }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.stock')" min-width="80" sortable prop="Stock">
                <div slot-scope="{ row }">
                  {{ row.Stock }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.packing')" min-width="80" sortable prop="Packing">
                <div slot-scope="{ row }">
                  <a
                    v-if="row.Packing > 0"
                    href="javascript:void(0)"
                    class="font-weight-bold text-primary"
                    @click="openPackingDetail(row)"
                  >
                    {{ row.Packing }}
                  </a>
                  <span v-else>{{ row.Packing }}</span>
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.balance')" min-width="80" sortable prop="Balance">
                <div slot-scope="{ row }">
                  {{ row.Balance }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.stock_sync_percentage')" min-width="80" align="center">
                <div slot-scope="{ row }">
                  {{ row.WmsProductSyncPercentage ? row.WmsProductSyncPercentage + '%' : '-' }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.stock_sync_threshold')" min-width="120" align="center">
                <div slot-scope="{ row }">
                  {{ row.WmsProductSyncThreshold ? row.WmsProductSyncThreshold : '-' }}
                </div>
              </el-table-column>

              <el-table-column :label="$t('wms.stock_alarm_threshold')" min-width="120" align="center">
                <div slot-scope="{ row }">
                  {{ row.WmsProductAlarmThreshold ? row.WmsProductAlarmThreshold : '-' }}
                </div>
              </el-table-column>

              <el-table-column
                width="100"
                align="center"
                :label="$t('wms.stock_sync_status')"
              >
                <div slot-scope="{ row }" class="d-flex justify-content-center">
                  <el-switch
                    v-model="row.WmsProductSyncEnabled"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#909399"
                    @change="handleStockSyncToggle(row)"
                  >
                  </el-switch>
                </div>
              </el-table-column>

              <el-table-column
                width="100"
                align="center"
                :label="$t('wms.stock_alarm_status')"
              >
                <div slot-scope="{ row }" class="d-flex justify-content-center">
                  <el-switch
                    v-model="row.WmsProductAlarmEnabled"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#f5365c"
                    inactive-color="#909399"
                    @change="handleStockAlarmToggle(row)"
                  >
                  </el-switch>
                </div>
              </el-table-column>

              <el-table-column
                width="100"
                align="center"
                :label="$t('actions')"
              >
                <div slot-scope="{ row }" class="d-flex justify-content-center">
                  <base-button
                    @click.native="handleSettings(row)"
                    class="edit"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-cog"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <!-- Packing Detail Modal -->
    <modal :show.sync="showPackingModal" modal-classes="modal-lg">
      <h5 slot="header" class="modal-title">
        {{ $t('wms.packing_detail') }} - {{ packingDetail.product_name }}
      </h5>
      <div v-loading="packingLoading">
        <div class="row mb-3" v-if="packingDetail.total_orders != null">
          <div class="col-md-6">
            <div class="text-muted small">{{ $t('wms.packing_total_orders') }}</div>
            <div class="h3 mb-0">{{ packingDetail.total_orders }}</div>
          </div>
          <div class="col-md-6">
            <div class="text-muted small">{{ $t('wms.packing_total_quantity') }}</div>
            <div class="h3 mb-0">{{ packingDetail.total_quantity }}</div>
          </div>
        </div>

        <h5>{{ $t('wms.packing_by_platform') }}</h5>
        <el-table :data="packingDetail.by_platform || []" stripe size="small" class="mb-3">
          <el-table-column :label="$t('wms.platform')" prop="platform" min-width="160">
            <template slot-scope="{row}">{{ (row.platform || '-') }}</template>
          </el-table-column>
          <el-table-column :label="$t('wms.packing_order_count')" prop="order_count" align="right" width="140">
            <template slot-scope="{row}">
              <a
                v-if="row.order_count > 0"
                href="javascript:void(0)"
                class="font-weight-bold text-primary"
                @click="openPackingOrderList('platform', row)"
              >{{ row.order_count }}</a>
              <span v-else>{{ row.order_count }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('wms.packing_quantity')" prop="quantity" align="right" width="140"></el-table-column>
        </el-table>

        <h5>{{ $t('wms.packing_by_sale_channel') }}</h5>
        <el-table :data="packingDetail.by_sale_channel || []" stripe size="small">
          <el-table-column :label="$t('wms.sale_channel') || 'Sale channel'" min-width="200">
            <template slot-scope="{row}">{{ row.name || ('#' + row.sale_channel_id) }}</template>
          </el-table-column>
          <el-table-column :label="$t('wms.packing_order_count')" prop="order_count" align="right" width="140">
            <template slot-scope="{row}">
              <a
                v-if="row.order_count > 0"
                href="javascript:void(0)"
                class="font-weight-bold text-primary"
                @click="openPackingOrderList('sale_channel', row)"
              >{{ row.order_count }}</a>
              <span v-else>{{ row.order_count }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('wms.packing_quantity')" prop="quantity" align="right" width="140"></el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <button type="button" class="btn btn-md btn-link ml-auto" @click="showPackingModal = false">
          {{ $t('close') }}
        </button>
      </template>
    </modal>

    <!-- Stock Settings Modal -->
    <modal :show.sync="showSettingsModal" modal-classes="modal-secondary">
      <h5 slot="header" class="modal-title">{{ $t('wms.stock_settings') }} - {{ settingsData.name }}</h5>
      <form class="new-event--form" @submit.prevent="">

        <div class="row">
          <div class="col-md-12">
            <base-input
              :label="$t('wms.stock_sync_percentage')"
              v-model="settingsData.stock_sync_percentage"
              type="number"
              min="0"
              max="100"
            >
            </base-input>
          </div>
          <div class="col-md-12">
            <base-input
              :label="$t('wms.stock_sync_threshold')"
              v-model="settingsData.stock_sync_threshold"
              type="number"
              min="0"
            >
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <base-input
              :label="$t('wms.stock_alarm_threshold')"
              v-model="settingsData.stock_alarm_threshold"
              type="number"
              min="0"
            >
            </base-input>
          </div>
        </div>

      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleSaveSettings()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showSettingsModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Switch } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import wmsProductRefetchOnActivate from "@/mixins/wmsProductRefetchOnActivate";
import { filterRowsByActiveProducts } from "@/utils/wmsProductActive";
import swal from "sweetalert2";
import { mapActions } from "vuex";
import { utils, writeFile } from 'xlsx';

export default {
  mixins: [clientPaginationMixin, wmsProductRefetchOnActivate],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Switch.name]: Switch,
  },
  data() {
    return {
      propsToSearch: ["ProductName"],
      tableData: [],
      loading: false,
      showSettingsModal: false,
      showPackingModal: false,
      packingLoading: false,
      packingProductId: null,
      packingDetail: { product_name: "", total_orders: null, total_quantity: 0, by_platform: [], by_sale_channel: [] },
      settingsData: {
        id: 0,
        name: "",
        stock_sync_percentage: 100,
        stock_sync_threshold: 0,
        stock_alarm_threshold: 0,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions({
      calculateStock: "Product/calculateStock",
      listProduct: "WmsProduct/listData",
      packingOrders: "Product/packingOrders",
      toggleStockSync: "WmsProduct/toggleStockSync",
      toggleStockAlarm: "WmsProduct/toggleStockAlarm",
      updateStockSettings: "WmsProduct/updateStockSettings",
    }),
    openPackingOrderList(type, row) {
      var query = { product_id: this.packingProductId, type: type };
      if (type === 'platform') {
        query.platform_id = row.platform_id;
      } else {
        query.sale_channel_id = row.sale_channel_id;
      }
      var resolved = this.$router.resolve({ name: 'WmsAvailableProductPackingOrders', query: query });
      window.open(resolved.href, '_blank');
    },
    async openPackingDetail(row) {
      this.packingProductId = row.ProductID;
      this.packingDetail = {
        product_name: row.ProductName,
        total_orders: null,
        total_quantity: 0,
        by_platform: [],
        by_sale_channel: [],
      };
      this.showPackingModal = true;
      this.packingLoading = true;
      try {
        const resp = await this.packingOrders(row.ProductID);
        const data = (resp.data && resp.data.Datum) || (resp.data && resp.data.Data && resp.data.Data[0]) || {};
        this.packingDetail = {
          product_name: row.ProductName,
          total_orders: data.total_orders || 0,
          total_quantity: data.total_quantity || 0,
          by_platform: (data.by_platform || []).slice().sort(function(a, b) { return b.order_count - a.order_count; }),
          by_sale_channel: (data.by_sale_channel || []).slice().sort(function(a, b) { return b.order_count - a.order_count; }),
        };
      } catch (e) {
        console.log(e);
        var errorMsg = (e.response && e.response.data && e.response.data.Msg) ? this.$t(e.response.data.Msg) : "error";
        var errorCause = (e.response && e.response.data && e.response.data.Cause) ? e.response.data.Cause : "";
        swal.fire({
          title: errorMsg,
          text: errorCause,
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false,
        });
      }
      this.packingLoading = false;
    },
    // kept-alive tab: a product enabled/disabled elsewhere shows up on return
    refetchWmsProducts() {
      return this.loadData();
    },
    async loadData() {
      this.loading = true;
      try {
        // owner 2026-10-11: only WMS products that are enabled (is_active) —
        // /products/calculate returns every product, so drop rows whose
        // ProductID is not in the active list (list empty / failed = no filter)
        const [resp, activeProducts] = await Promise.all([this.calculateStock(), this.listProduct()]);
        const wmsStock = resp.data.Datum.wms_stock || [];
        const wmsProducts = resp.data.Datum.wms_products || [];

        // Create a map of wms_product by id for quick lookup
        const productMap = {};
        wmsProducts.forEach(function(product) {
          productMap[product.id] = product;
        });

        console.log(productMap);

        // Merge wms_stock with stock_sync_* and stock_alarm_* from wms_product
        // Filter out items without matching product
        this.tableData = filterRowsByActiveProducts(wmsStock, activeProducts)
          .filter(function(stock) {
            const product = productMap[stock.ProductID];
            if (!product) {
              console.log("No matching product for stock:", stock);
              return false;
            }
            return true;
          })
          .map(function(stock) {
            const product = productMap[stock.ProductID];
            return {
              ...stock,
              WmsProductSyncEnabled: product.stock_sync_enabled,
              WmsProductSyncPercentage: product.stock_sync_percentage,
              WmsProductSyncThreshold: product.stock_sync_threshold,
              WmsProductAlarmEnabled: product.stock_alarm_enabled,
              WmsProductAlarmThreshold: product.stock_alarm_threshold
            };
          });
      } catch (error) {
        console.log(error);
        this.tableData = [];
      } finally {
        this.loading = false;
      }
    },
    handleStockSyncToggle(row) {
      var self = this;
      this.toggleStockSync({
        id: row.ProductID,
        payload: { StockSyncEnabled: row.WmsProductSyncEnabled }
      })
      .then(function(resp) {
        swal.fire({
          title: "Success",
          text: "Stock sync " + (row.WmsProductSyncEnabled ? "enabled" : "disabled"),
          icon: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      })
      .catch(function(err) {
        row.WmsProductSyncEnabled = row.WmsProductSyncEnabled ? 0 : 1;
        var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? self.$t(err.response.data.Msg) : "error";
        var errorCause = (err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : "";
        swal.fire({
          title: errorMsg,
          text: errorCause,
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      });
    },
    handleStockAlarmToggle(row) {
      var self = this;
      this.toggleStockAlarm({
        id: row.ProductID,
        payload: { StockAlarmEnabled: row.WmsProductAlarmEnabled }
      })
      .then(function(resp) {
        swal.fire({
          title: "Success",
          text: "Stock alarm " + (row.WmsProductAlarmEnabled ? "enabled" : "disabled"),
          icon: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      })
      .catch(function(err) {
        row.WmsProductAlarmEnabled = row.WmsProductAlarmEnabled ? 0 : 1;
        var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? self.$t(err.response.data.Msg) : "error";
        var errorCause = (err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : "";
        swal.fire({
          title: errorMsg,
          text: errorCause,
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      });
    },
    handleSettings(row) {
      console.log(row);
      this.settingsData.id = row.ProductID;
      this.settingsData.name = row.ProductName;
      this.settingsData.stock_sync_percentage = row.WmsProductSyncPercentage ;
      this.settingsData.stock_sync_threshold = row.WmsProductSyncThreshold ;
      this.settingsData.stock_alarm_threshold = row.WmsProductAlarmThreshold ;
      this.showSettingsModal = true;
    },
    handleSaveSettings() {
      var self = this;
      this.updateStockSettings({
        id: this.settingsData.id,
        payload: {
          StockSyncPercentage: parseInt(this.settingsData.stock_sync_percentage),
          StockSyncThreshold: parseInt(this.settingsData.stock_sync_threshold),
          StockAlarmThreshold: parseInt(this.settingsData.stock_alarm_threshold)
        }
      })
      .then(function(resp) {
        self.showSettingsModal = false;
        self.loadData();
        swal.fire({
          title: self.$t("edit_success"),
          text: "",
          icon: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      })
      .catch(function(err) {
        var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? self.$t(err.response.data.Msg) : "error";
        var errorCause = (err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : "";
        swal.fire({
          title: errorMsg,
          text: errorCause,
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      });
    },
    exportData() {
      let dataExport = this.tableData.map((item) => {
        return {
          ProductID: item.ProductID,
          ProductName: item.ProductName,
          Stock: item.Stock,
          Packing: item.Packing,
          Balance: item.Balance,
          StockSyncEnabled: item.WmsProductSyncEnabled,
          StockSyncThreshold: item.WmsProductSyncThreshold,
          StockSyncPercentage: item.WmsProductSyncPercentage,
          StockAlarmEnabled: item.WmsProductAlarmEnabled,
          StockAlarmThreshold: item.WmsProductAlarmThreshold,
        };
      });
      const dataWS = utils.json_to_sheet(dataExport);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, dataWS);
      writeFile(wb, 'export_available_product.xlsx');
    },
    GetProductUrl(filename) {
      if (!filename) return "";
      return process.env.VUE_APP_API_BASE_URL + "/files/wms_products/" + filename;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
